module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/aleg8-39526ad46b86b464ea2cf40f0e4db33a.jpg";